import { render, staticRenderFns } from "./EssayReview.vue?vue&type=template&id=0474010c&scoped=true&"
import script from "./EssayReview.vue?vue&type=script&lang=js&"
export * from "./EssayReview.vue?vue&type=script&lang=js&"
import style0 from "./EssayReview.vue?vue&type=style&index=0&id=0474010c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474010c",
  null
  
)

export default component.exports